/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type QACategory = "ALL_SIZEABLE_PALLETS_LABELED" | "BOXES_CORNERS_ACCURATE" | "BOXES_OFF_PALLET_LABELED" | "BOXES_ON_PALLET_LABELED" | "BOX_TOPS_LABELED" | "CORNER_VISIBILITY_MARKED" | "PALLETS_CORNERS_ACCURATE" | "PALLETS_SURFACES_CORRECT" | "PALLET_POCKETS_CORNERS_ACCURATE" | "PALLET_SIDES" | "PALLET_TYPE_CORRECT" | "TARGETED_PALLET_LABELED" | "%future added value";
export type CreateIssueDialog_frame = {
    readonly id: string;
    readonly sensorStream: {
        readonly id: string;
    };
    readonly labelers: ReadonlyArray<{
        readonly id: string;
        readonly username: string | null;
        readonly shortName: string | null;
    }>;
    readonly labeledBoxes: ReadonlyArray<{
        readonly id: string;
        readonly number: number;
    }>;
    readonly labeledPallets: ReadonlyArray<{
        readonly id: string;
        readonly number: number;
    }>;
    readonly qaInspections: ReadonlyArray<{
        readonly category: QACategory;
    }>;
    readonly " $refType": "CreateIssueDialog_frame";
};
export type CreateIssueDialog_frame$data = CreateIssueDialog_frame;
export type CreateIssueDialog_frame$key = {
    readonly " $data"?: CreateIssueDialog_frame$data;
    readonly " $fragmentRefs": FragmentRefs<"CreateIssueDialog_frame">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = [
  (v0/*: any*/),
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "number",
    "args": null,
    "storageKey": null
  }
];
return {
  "kind": "Fragment",
  "name": "CreateIssueDialog_frame",
  "type": "Frame",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "sensorStream",
      "storageKey": null,
      "args": null,
      "concreteType": "SensorStream",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "labelers",
      "storageKey": null,
      "args": null,
      "concreteType": "LabelerUser",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "username",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "shortName",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "labeledBoxes",
      "storageKey": null,
      "args": null,
      "concreteType": "LabeledBox",
      "plural": true,
      "selections": (v1/*: any*/)
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "labeledPallets",
      "storageKey": null,
      "args": null,
      "concreteType": "LabeledPallet",
      "plural": true,
      "selections": (v1/*: any*/)
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "qaInspections",
      "storageKey": null,
      "args": null,
      "concreteType": "QAInspection",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "category",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
})();
(node as any).hash = '1af8fe51ffab4e5d7f2a3d73a4dc1826';
export default node;
